import { css } from '@stitches/core';
import { generateClassNames } from '@supabase/auth-ui-shared';
var inputDefaultStyles = css({
    fontFamily: '$inputFontFamily',
    background: '$inputBackground',
    borderRadius: '$inputBorderRadius',
    padding: '$inputPadding',
    cursor: 'text',
    borderWidth: '$inputBorderWidth',
    borderColor: '$inputBorder',
    borderStyle: 'solid',
    fontSize: '$baseInputSize',
    width: '100%',
    color: '$inputText',
    boxSizing: 'border-box',
    '&:hover': {
        borderColor: '$inputBorderHover',
        outline: 'none'
    },
    '&:focus': {
        borderColor: '$inputBorderFocus',
        outline: 'none'
    },
    '&::placeholder': {
        color: '$inputPlaceholder',
        letterSpacing: 'initial'
    },
    transitionProperty: 'background-color, border',
    transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
    transitionDuration: '100ms',
    variants: {
        type: {
            "default": {
                letterSpacing: '0px'
            },
            password: {
                letterSpacing: '0px'
            }
        }
    }
});
var Input = function (props) {
    var _a, _b;
    var classNames = generateClassNames('input', inputDefaultStyles({
        type: props.type === 'password' ? 'password' : 'default'
    }), props.appearance);
    return (<input {...props} style={(_b = (_a = props.appearance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.input} class={classNames.join(' ')}>
      {props.children}
    </input>);
};
export { Input };
